module.exports = __webpack_public_path__ + "static/img/img_form2_zh_cn.77e3f079.png";